import * as yup from 'yup';

export const getEditSubscriptionSchema = yup.object().shape({
  // domain: yup.string().required('Ce champs est requis'),
  fieldOfActivity: yup.string().required('Ce champs est requis'),
});
